// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20vGy","toggle":"styles_toggle__2uI-I","preview":"styles_preview__Fzl3B"};